import { FormikErrors } from 'formik';
import { ICrmActivityFormValues } from '../types';

export const validateCrmCreateActivityForm = (values: ICrmActivityFormValues) => {
  const errors: FormikErrors<ICrmActivityFormValues> = {};
  if (!values.topic?.trim().length) {
    errors.topic = 'Field Required';
  }
  if (values.participantDirectoryEntryIds.length < 1) {
    errors.participantDirectoryEntryIds = 'Field Required';
  }
  if (values.categories.length < 1) {
    errors.categories = 'Field Required';
  }
  return errors;
};
